import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Page.css';

function Privacy() {
  return (
    <div className="page-wrapper">
      <Header />
      <main className="page-main">
        <div className="page-container">
          <div className="page-content">
            <Link to="/" className="back-link">← Назад</Link>
            <h1>Политика конфиденциальности</h1>
            <div className="page-text">
              <p>
                Настоящий Договор является официальным предложением (публичной офертой) Исполнителя заключить договор на предоставление услуг на условиях, изложенных ниже.
              </p>
              
              <h2>1. ОБЩИЕ ПОЛОЖЕНИЯ</h2>
              <p>
                1.1. Акцептом оферты считается совершение Пользователем действий, направленных на использование Сервиса, включая внесение платежей. Акцепт означает полное и безоговорочное принятие всех условий Договора.
              </p>
              <p>
                1.2. Исполнитель вправе изменять условия оферты в одностороннем порядке. Новая редакция вступает в силу с момента её публикации. Использование Сервиса после изменений означает согласие с ними.
              </p>

              <h2>2. ПЕРЕЧЕНЬ УСЛУГ</h2>
              <p>
                2.1. Сервис предоставляет автоматизированные услуги:
              </p>
              <ul>
                <li>Продажа виртуальных активов «Telegram Stars»;</li>
                <li>Оформление подписки «Telegram Premium»;</li>
                <li>Приём платежей для приобретения «Telegram Stars».</li>
              </ul>
              <p>
                2.2. Услуги считаются оказанными с момента зачисления средств на счёт Пользователя в платформе Telegram.
              </p>

              <h2>3. СТОИМОСТЬ И ПОРЯДОК РАСЧЁТОВ</h2>
              <p>
                3.1. Оплата осуществляется через платёжные системы, интегрированные в Сервис.
              </p>
              <p>
                3.2. Услуги оказываются после полной предоплаты.
              </p>
              <p>
                3.3. Все транзакции являются окончательными. Возврат средств возможен только в случаях, предусмотренных разделом 5 Договора.
              </p>

              <h2>4. СРОКИ ОКАЗАНИЯ УСЛУГ</h2>
              <p>
                4.1. Стандартный срок зачисления средств — от 1 минуты до 24 часов.
              </p>
              <p>
                4.2. В периоды технических работ или повышенной нагрузки платформы Telegram возможны задержки.
              </p>

              <h2>5. ВОЗВРАТ СРЕДСТВ</h2>
              <p>
                5.1. Возврат осуществляется при:
              </p>
              <ul>
                <li>Неоказании услуги в течение 24 часов;</li>
                <li>Техническом сбое, подтверждённом Исполнителем.</li>
              </ul>
              <p>
                5.2. Возврат производится в эквиваленте оплаченной суммы в «Telegram Stars» на счёт Пользователя в течение 2 рабочих дней.
              </p>

              <h2>6. ОБРАБОТКА ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
              <p>
                6.1. Исполнитель обрабатывает данные в соответствии с Федеральным законом № 152-ФЗ «О персональных данных».
              </p>
              <p>
                6.2. Состав данных:
              </p>
              <ul>
                <li>Идентификатор Telegram;</li>
                <li>IP-адрес;</li>
                <li>Номер телефона;</li>
                <li>Публичные данные профиля;</li>
                <li>Транзакционная история.</li>
              </ul>
              <p>
                6.3. Цели обработки:
              </p>
              <ul>
                <li>Исполнение Договора;</li>
                <li>Противодействие мошенничеству;</li>
                <li>Техническая поддержка.</li>
              </ul>
              <p>
                6.4. Данные хранятся на защищённых серверах на территории РФ в течение срока действия учётной записи.
              </p>

              <h2>7. ПРАВИЛА ИСПОЛЬЗОВАНИЯ СЕРВИСА</h2>
              <p>
                7.1. Запрещено использование Сервиса для незаконных операций.
              </p>
              <p>
                7.2. Исполнитель вправе отказать в обслуживании без объяснения причин.
              </p>

              <h2>8. РЕКВИЗИТЫ И КОНТАКТЫ</h2>
              <p>
                Исполнитель: Telegram: @huesellerbot
              </p>
              <p>
                Поддержка: Обращения принимаются через аккаунт @ignatmalikov в течение 24 часов с момента возникновения спора.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Privacy;

